export default {
  schema: {
    type: 'object',
    properties: {
      static_unlabelled: {
        type: 'object',
        properties: {
          sample_question: {
            type: 'string',
            title: 'Sample Question',
            maxLength: 20000
          }
        },
        required: [],
        dependencies: {},
        additionalProperties: false,
        title: ''
      },
      // this is how the back-end is currently returning unlabeled static sub-components; no title at all here or uiSchema
      static_unlabelled_no_title: {
        type: 'object',
        properties: {
          sample_question: {
            type: 'string',
            title: 'Sample Question',
            maxLength: 20000
          }
        },
        required: [],
        dependencies: {},
        additionalProperties: false
      },
      static_labelled: {
        type: 'object',
        properties: {
          sample_question: {
            type: 'string',
            title: 'Sample Question',
            maxLength: 20000
          }
        },
        required: ['sample_question'],
        dependencies: {},
        additionalProperties: false,
        title: 'Labelled <i>Static</i> Component'
      },
      name_group: {
        type: 'object',
        properties: {
          faculty_name: {
            type: 'string',
            title: 'People at Demo',
            $ref: '#/definitions/users'
          },
          fname: {
            type: 'string',
            title: 'First Name',
            maxLength: 20000
          },
          mname: {
            type: 'string',
            title: 'Middle Name/Initial',
            maxLength: 20000
          },
          lname: {
            type: 'string',
            title: 'Last Name',
            maxLength: 20000
          }
        },
        required: [],
        dependencies: {},
        additionalProperties: false,
        title: 'Name Group inside Static DSA'
      },
      position_group: {
        type: 'object',
        properties: {
          org: {
            type: 'string',
            title: 'Org',
            maxLength: 20000
          },
          position: {
            type: 'string',
            title: 'Poisition',
            maxLength: 20000
          },
          dtm_start: {
            type: 'string',
            title: 'Month',
            $ref: '#/definitions/months-1735515'
          },
          dtd_start: {
            type: 'integer',
            title: 'Day',
            minimum: 1,
            maximum: 31
          },
          dty_start: {
            type: 'integer',
            title: 'Year',
            minimum: 1900,
            maximum: 2100
          },
          dtm_end: {
            type: 'string',
            title: 'Month',
            $ref: '#/definitions/months-1735515'
          },
          dtd_end: {
            type: 'integer',
            title: 'Day',
            minimum: 1,
            maximum: 31
          },
          dty_end: {
            type: 'integer',
            title: 'Year',
            minimum: 1900,
            maximum: 2100
          },
          desc: {
            type: 'string',
            title: 'Description',
            maxLength: 20000
          }
        },
        required: [],
        dependencies: {
          dtm_start: ['dty_start'],
          dtd_start: ['dtm_start'],
          dtm_end: ['dty_end'],
          dtd_end: ['dtm_end']
        },
        additionalProperties: false,
        title: 'Position inside Static DSA',
        allOf: [{
          allOf: [{
            if: {
              properties: {
                dtm_start: {
                  enum: ['1735519', '1735521', '1735524', '1735526']
                }
              }
            },
            then: {
              properties: {
                dtd_start: {
                  maximum: 30
                }
              }
            }
          }, {
            if: {
              allOf: [{
                properties: {
                  dtm_start: {
                    const: '1735517'
                  }
                }
              }, {
                oneOf: [{
                  properties: {
                    dty_start: {
                      multipleOf: 4,
                      not: {
                        multipleOf: 100
                      }
                    }
                  }
                }, {
                  properties: {
                    dty_start: {
                      multipleOf: 400
                    }
                  }
                }]
              }]
            },
            then: {
              properties: {
                dtd_start: {
                  maximum: 29
                }
              }
            }
          }, {
            if: {
              allOf: [{
                properties: {
                  dtm_start: {
                    const: '1735517'
                  }
                }
              }, {
                properties: {
                  dty_start: {
                    not: {
                      multipleOf: 4
                    }
                  }
                }
              }]
            },
            then: {
              properties: {
                dtd_start: {
                  maximum: 28
                }
              }
            }
          }, {
            if: {
              allOf: [{
                properties: {
                  dtm_start: {
                    const: '1735517'
                  }
                }
              }, {
                properties: {
                  dty_start: {
                    multipleOf: 100,
                    not: {
                      multipleOf: 400
                    }
                  }
                }
              }]
            },
            then: {
              properties: {
                dtd_start: {
                  maximum: 28
                }
              }
            }
          }]
        }, {
          allOf: [{
            if: {
              properties: {
                dtm_end: {
                  enum: ['1735519', '1735521', '1735524', '1735526']
                }
              }
            },
            then: {
              properties: {
                dtd_end: {
                  maximum: 30
                }
              }
            }
          }, {
            if: {
              allOf: [{
                properties: {
                  dtm_end: {
                    const: '1735517'
                  }
                }
              }, {
                oneOf: [{
                  properties: {
                    dty_end: {
                      multipleOf: 4,
                      not: {
                        multipleOf: 100
                      }
                    }
                  }
                }, {
                  properties: {
                    dty_end: {
                      multipleOf: 400
                    }
                  }
                }]
              }]
            },
            then: {
              properties: {
                dtd_end: {
                  maximum: 29
                }
              }
            }
          }, {
            if: {
              allOf: [{
                properties: {
                  dtm_end: {
                    const: '1735517'
                  }
                }
              }, {
                properties: {
                  dty_end: {
                    not: {
                      multipleOf: 4
                    }
                  }
                }
              }]
            },
            then: {
              properties: {
                dtd_end: {
                  maximum: 28
                }
              }
            }
          }, {
            if: {
              allOf: [{
                properties: {
                  dtm_end: {
                    const: '1735517'
                  }
                }
              }, {
                properties: {
                  dty_end: {
                    multipleOf: 100,
                    not: {
                      multipleOf: 400
                    }
                  }
                }
              }]
            },
            then: {
              properties: {
                dtd_end: {
                  maximum: 28
                }
              }
            }
          }]
        }]
      }
    },
    required: [],
    dependencies: {},
    additionalProperties: false,
    definitions: {
      users: {
        enum: ['1948810', '1948787', '2100605', '2028735', '1948828', '1948832', '2041026', '1948747', '1958550', '1941300', '1941301', '1948842', '1948831', '1948928', '1948800', '1948934', '1948784', '1948786', '1958551', '1960640', '1958548', '1941308', '1941309', '1948943', '1948930', '1948940', '2028724', '2028734', '1948941', '1948931', '1948791', '1948927', '1940039', '2171590', '1941323', '1948834', '1948936', '1948939', '2028733', '1948814', '1948884', '1948938', '1948809', '1948933', '1948792', '1948890', '1948793', '1948824', '1948789', '1960636', '2135059', '1948942', '2100606', '1948888', '1960639', '1960637', '2171591', '2028729', '2028738', '1948839', '2162076', '1948932', '1960635', '1948790', '1948811', '1948937', '1958552', '1948795', '1958553', '1955575', '2091505', '1973184', '1960634', '1948830', '1940616', '1948785', '2028737', '1940620', '2061332', '1781418', '1948829', '1948693', '1948883', '2028723', '2028731', '56104', '1940036', '1958522', '1948929', '2141685', '2091181', '1948806', '1948935', '1940573'],
        enumNames: ['Adalberto, Jonathan (jadalberto)', 'Adelaida, Ruth (radelaida)', 'Akerman, Kyle (kakerman)', 'Alexei, Jasmine (lawd)', 'Alkaios, Amina (aalkaios)', 'Amedee, Gregg (gamedee)', 'Babe, Kris (kbabe)', 'Bader, Charley (cbader)', 'Baldric, Elio (ebaldric)', 'Bentley, Miles (businessd)', 'Bernsteen, Mallory (mbernsteen)', 'Berta, Derby (dberta)', 'Beyza, Casper (nursingf)', 'Bihter, Catherine (cbither)', 'Brennan, Franklin (fbrennan)', 'Cadoc, Robert (rcadoc)', 'Caren, Cecile (ccaren)', 'Clopas, Nigel (nclopas)', 'Como, Zack (educationf)', 'Constantine, Laci  (educationd)', 'Damon, Spencer (sdamon)', 'Daniels, Clive (cdaniels)', 'Davis, Oliver (odavis)', 'Dejan, Annette (adejan)', 'Eduard, Nydia (neduard)', 'Ekram, Oliver (medicinef)', 'Eric, Indra (ieric)', 'Esteve, Riley (resteve)', 'Eveline, Tabatha (teveline)', 'Feliu, Luther (lfeliu)', 'Finlay, Ian (engineeringf)', 'Florentino, Ascher  (aflorentino)', 'Fodor, Paul (pfodor)', 'Fuger, Anthony (afuger+1111)', 'Giles, Andrea (agiles)', 'Gudron, Bruno (provost_placeholder)', 'Haroun, Angelicka (aharoun)', 'Harrington, Stephan (sharrington)', 'Helga, Kristiane (khelga)', 'Huppert, Katrine (khuppert)', 'Irma, Gerard (girma)', 'Jean, Paul (pjean)', 'Kai, Rama (nursingd)', 'Leo, Rasheed (medicined)', 'Leonhard, Ross (rleonhard)', 'Liwia, Shawna (sliwia)', 'Ludo, Maria (mludo)', 'Luz, Nik (nluz)', 'Mahon, Irma (engineeringd)', 'Maikel, Clark (cmaikel)', 'Manrique, Kristian (kmanrique)', 'Marcelino, Malina (mmarcelino)', 'McKinley, Michael (mmckinley)', 'Mitchell, Alex (artsd)', 'Monte, Lyla (lmonte)', 'Montgomery, Jarred (jmontgomery)', 'Moulton, Mattest (mtest)', 'Nadav, Nadav (dnadav)', 'Nibilo, Eldridge (enibilo)', 'Nilda, Keely (Knilda)', 'Nisar, Seema (snisar)', 'Noor, Charlize (cnoor)', 'Odran, Collin (codran)', 'Oliver, Ron (roliver)', 'Ornat, Morgan (mornat)', 'Otto, Ala (aotto)', 'Porter, Christian (cporter)', 'Ragna, Claudette (cragna)', 'Read, August (aread)', 'Roberts, Amanda (amroberts)', 'Rodgers, Tom (thomas.rodgers)', 'Ronald, Dennis (dronald)', 'Roselyn, Kristine (kroselyn)', 'Ruby, Meg (mruby)', 'Schmidt, Donald (businessf)', 'Shila, Peter (pshila)', 'Silvio, Darleen (lawf)', 'Simons, Samuel  (ssimons)', 'Sinclair, Alex (afuger)', 'Smith, Margaret (msmith)', 'Solfrid, Christin (csolfrid)', 'Sonje, Mari (msonje)', 'Teodora, Marietta (mteodora)', 'Terrence, Jeremy (jterrence)', 'Thaddeus, Danilo (dthaddeus)', 'Thomas, Jerry (jthomas)', 'Thompson, Jessica (jthompson)', 'Thompson, Karen (provost)', 'Topias, David (dtopias)', 'User, Empty (emptyuser)', 'Vincent, Ben (br.vincent91)', 'Viola, Sara (sviola)', 'Vipul, Marta (mvipul)', 'West, Mary (mwest)']
      },
      'months-1735515': {
        enum: ['1735516', '1735517', '1735518', '1735519', '1735520', '1735521', '1735522', '1735523', '1735524', '1735525', '1735526', '1735527'],
        enumNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      }
    },
    title: 'Static Sub-Component Example',
    allOf: [{
      anyOf: [{
        properties: {
          name_group: {
            required: ['faculty_name'],
            properties: {
              faculty_name: {
                const: '1948810'
              }
            }
          }
        }
      }]
    }]
  },
  uiSchema: {
    'dm:layout': [{
      id: 'static_unlabelled',
      type: 'field'
    }, {
      id: 'static_unlabelled_no_title',
      type: 'field'
    }, {
      id: 'static_labelled',
      type: 'field'
    }, {
      id: 'name_group',
      type: 'field'
    }, {
      id: 'position_group',
      type: 'field'
    }],
    static_unlabelled: {
      'dm:layout': [{
        id: 'sample_question',
        type: 'field'
      }],
      sample_question: {
        'ui:title': {
          text: 'Sample Question',
          escape: true
        },
        'ui:widget': 'text'
      }
    },
    static_unlabelled_no_title: {
      'dm:layout': [{
        id: 'sample_question',
        type: 'field'
      }],
      sample_question: {
        'ui:title': {
          text: 'Sample Question',
          escape: true
        },
        'ui:widget': 'text'
      }
    },
    static_labelled: {
      'dm:layout': [{
        id: 'sample_question',
        type: 'field'
      }],
      'ui:title': {
        escape: false
      },
      sample_question: {
        'ui:title': {
          text: 'Sample <i>Question</i>',
          escape: false
        },
        'ui:widget': 'text'
      }
    },
    name_group: {
      'dm:layout': [{
        id: 'faculty_name',
        type: 'field'
      }, {
        id: 'fname',
        type: 'field'
      }, {
        id: 'mname',
        type: 'field'
      }, {
        id: 'lname',
        type: 'field'
      }],
      faculty_name: {
        'ui:title': {
          text: 'People at Demo',
          escape: true
        },
        'ui:widget': 'select'
      },
      fname: {
        'ui:title': {
          text: 'First Name',
          escape: true
        },
        'ui:widget': 'text'
      },
      mname: {
        'ui:title': {
          text: 'Middle Name/Initial',
          escape: true
        },
        'ui:widget': 'text'
      },
      lname: {
        'ui:title': {
          text: 'Last Name',
          escape: true
        },
        'ui:widget': 'text'
      }
    },
    position_group: {
      'dm:layout': [{
        id: 'org',
        type: 'field'
      }, {
        id: 'position',
        type: 'field'
      }, {
        id: '2099371',
        type: 'group',
        children: [{
          id: 'dtm_start',
          type: 'field'
        }, {
          id: 'dtd_start',
          type: 'field'
        }, {
          id: '2099374',
          type: 'text'
        }, {
          id: 'dty_start',
          type: 'field'
        }]
      }, {
        id: '2099376',
        type: 'group',
        children: [{
          id: 'dtm_end',
          type: 'field'
        }, {
          id: 'dtd_end',
          type: 'field'
        }, {
          id: '2099379',
          type: 'text'
        }, {
          id: 'dty_end',
          type: 'field'
        }]
      }, {
        id: 'desc',
        type: 'field'
      }],
      org: {
        'ui:title': {
          text: 'Org',
          escape: true
        },
        'ui:widget': 'text'
      },
      position: {
        'ui:title': {
          text: 'Poisition',
          escape: true
        },
        'ui:widget': 'text'
      },
      '2099371': {
        'ui:title': {
          text: 'Start Date',
          escape: true
        },
        'ui:widget': 'text',
        'ui:options': {
          compact: true
        }
      },
      dtm_start: {
        'ui:title': {
          text: 'Month',
          escape: true
        },
        'ui:widget': 'select'
      },
      dtd_start: {
        'ui:title': {
          text: 'Day',
          escape: true
        },
        'ui:widget': 'text'
      },
      '2099374': {
        'ui:title': {
          text: ',',
          escape: true
        },
        'ui:widget': 'text'
      },
      dty_start: {
        'ui:title': {
          text: 'Year',
          escape: true
        },
        'ui:widget': 'text',
        'ui:options': {
          suppressFormatting: true
        }
      },
      '2099376': {
        'ui:title': {
          text: 'End Date',
          escape: true
        },
        'ui:widget': 'text',
        'ui:options': {
          compact: true
        }
      },
      dtm_end: {
        'ui:title': {
          text: 'Month',
          escape: true
        },
        'ui:widget': 'select'
      },
      dtd_end: {
        'ui:title': {
          text: 'Day',
          escape: true
        },
        'ui:widget': 'text'
      },
      '2099379': {
        'ui:title': {
          text: ',',
          escape: true
        },
        'ui:widget': 'text'
      },
      dty_end: {
        'ui:title': {
          text: 'Year',
          escape: true
        },
        'ui:widget': 'text',
        'ui:options': {
          suppressFormatting: true
        }
      },
      desc: {
        'ui:title': {
          text: 'Description',
          escape: true
        },
        'ui:widget': 'richtext'
      }
    }
  },
  triggerData: [{
    sources: ['name_group.faculty_name'],
    targets: ['fname', 'mname', 'lname'],
    data: {
      '1948810': ['Jonathan', '', 'Adalberto'],
      '1948787': ['Ruth', '', 'Adelaida'],
      '2100605': ['Kyle', '', 'Akerman'],
      '2028735': ['Jasmine', '', 'Alexei'],
      '1948828': ['Amina', '', 'Alkaios'],
      '1948832': ['Gregg', '', 'Amedee'],
      '2041026': ['Kris', '', 'Babe'],
      '1948747': ['Charley', '', 'Bader'],
      '1958550': ['Elio', '', 'Baldric'],
      '1941300': ['Miles', '', 'Bentley'],
      '1941301': ['Mallory', '', 'Bernsteen'],
      '1948842': ['Derby', '', 'Berta'],
      '1948831': ['Casper', '', 'Beyza'],
      '1948928': ['Catherine', '', 'Bihter'],
      '1948800': ['Franklin', '', 'Brennan'],
      '1948934': ['Robert', '', 'Cadoc'],
      '1948784': ['Cecile', '', 'Caren'],
      '1948786': ['Nigel', '', 'Clopas'],
      '1958551': ['Zack', '', 'Como'],
      '1960640': ['Laci ', '', 'Constantine'],
      '1958548': ['Spencer', '', 'Damon'],
      '1941308': ['Clive', '', 'Daniels'],
      '1941309': ['Oliver', '', 'Davis'],
      '1948943': ['Annette', '', 'Dejan'],
      '1948930': ['Nydia', '', 'Eduard'],
      '1948940': ['Oliver', '', 'Ekram'],
      '2028724': ['Indra', '', 'Eric'],
      '2028734': ['Riley', '', 'Esteve'],
      '1948941': ['Tabatha', '', 'Eveline'],
      '1948931': ['Luther', '', 'Feliu'],
      '1948791': ['Ian', '', 'Finlay'],
      '1948927': ['Ascher ', '', 'Florentino'],
      '1940039': ['Paul', '', 'Fodor'],
      '2171590': ['Anthony', '', 'Fuger'],
      '1941323': ['Andrea', '', 'Giles'],
      '1948834': ['Bruno', '', 'Gudron'],
      '1948936': ['Angelicka', '', 'Haroun'],
      '1948939': ['Stephan', '', 'Harrington'],
      '2028733': ['Kristiane', '', 'Helga'],
      '1948814': ['Katrine', '', 'Huppert'],
      '1948884': ['Gerard', '', 'Irma'],
      '1948938': ['Paul', '', 'Jean'],
      '1948809': ['Rama', '', 'Kai'],
      '1948933': ['Rasheed', '', 'Leo'],
      '1948792': ['Ross', '', 'Leonhard'],
      '1948890': ['Shawna', '', 'Liwia'],
      '1948793': ['Maria', '', 'Ludo'],
      '1948824': ['Nik', '', 'Luz'],
      '1948789': ['Irma', '', 'Mahon'],
      '1960636': ['Clark', '', 'Maikel'],
      '2135059': ['Kristian', '', 'Manrique'],
      '1948942': ['Malina', '', 'Marcelino'],
      '2100606': ['Michael', '', 'McKinley'],
      '1948888': ['Alex', '', 'Mitchell'],
      '1960639': ['Lyla', '', 'Monte'],
      '1960637': ['Jarred', '', 'Montgomery'],
      '2171591': ['Mattest', '', 'Moulton'],
      '2028729': ['Nadav', '', 'Nadav'],
      '2028738': ['Eldridge', '', 'Nibilo'],
      '1948839': ['Keely', '', 'Nilda'],
      '2162076': ['Seema', '', 'Nisar'],
      '1948932': ['Charlize', '', 'Noor'],
      '1960635': ['Collin', '', 'Odran'],
      '1948790': ['Ron', '', 'Oliver'],
      '1948811': ['Morgan', '', 'Ornat'],
      '1948937': ['Ala', '', 'Otto'],
      '1958552': ['Christian', '', 'Porter'],
      '1948795': ['Claudette', '', 'Ragna'],
      '1958553': ['August', '', 'Read'],
      '1955575': ['Amanda', '', 'Roberts'],
      '2091505': ['Tom', '', 'Rodgers'],
      '1973184': ['Dennis', '', 'Ronald'],
      '1960634': ['Kristine', '', 'Roselyn'],
      '1948830': ['Meg', '', 'Ruby'],
      '1940616': ['Donald', '', 'Schmidt'],
      '1948785': ['Peter', '', 'Shila'],
      '2028737': ['Darleen', '', 'Silvio'],
      '1940620': ['Samuel ', '', 'Simons'],
      '2061332': ['Alex', '', 'Sinclair'],
      '1781418': ['Margaret', '', 'Smith'],
      '1948829': ['Christin', '', 'Solfrid'],
      '1948693': ['Mari', '', 'Sonje'],
      '1948883': ['Marietta', '', 'Teodora'],
      '2028723': ['Jeremy', '', 'Terrence'],
      '2028731': ['Danilo', '', 'Thaddeus'],
      '56104': ['Jerry', '', 'Thomas'],
      '1940036': ['Jessica', '', 'Thompson'],
      '1958522': ['Karen', '', 'Thompson'],
      '1948929': ['David', '', 'Topias'],
      '2141685': ['Empty', '', 'User'],
      '2091181': ['Ben', '', 'Vincent'],
      '1948806': ['Sara', '', 'Viola'],
      '1948935': ['Marta', '', 'Vipul'],
      '1940573': ['Mary', '', 'West']
    }
  }],
  formData: {}
};